import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './lib/useTheme';
import { AuthProvider } from './lib/useAuth';
import { Toaster } from 'sonner';
import App from './App.tsx';
import './index.css';
import { initAnalyticsFromConsent, applyConsentPreferences } from '@/lib/analytics';
import { initWebMCP } from './lib/webmcp';
import type { ConsentPreferences } from '@/lib/consent';

initAnalyticsFromConsent();
initWebMCP();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

window.addEventListener('cookie-consent-update', (event) => {
  const detail = (event as CustomEvent<ConsentPreferences>).detail;
  if (detail) applyConsentPreferences(detail);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <App />
          <Toaster 
            theme="dark" 
            position="bottom-right" 
            toastOptions={{ 
              className: 'glass border border-white/10',
              duration: 4000 
            }} 
          />
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>,
);
